export default {
 "columns": 58,
 "image": "minecarts.png",
 "imageheight": 565,
 "imagewidth": 943,
 "margin": 0,
 "name": "minecarts",
 "spacing": 0,
 "tilecount": 2030,
 "tiledversion": "1.11.2",
 "tileheight": 16,
 "tiles": [
  {
   "id": 14,
   "type": "decal"
  },
  {
   "id": 15,
   "type": "decal"
  },
  {
   "id": 21,
   "type": "decal"
  },
  {
   "id": 49,
   "type": "decal"
  },
  {
   "id": 69,
   "type": "decal"
  },
  {
   "id": 70,
   "type": "decal"
  },
  {
   "id": 71,
   "type": "decal"
  },
  {
   "id": 72,
   "type": "decal"
  },
  {
   "id": 73,
   "type": "decal"
  },
  {
   "id": 78,
   "type": "decal"
  },
  {
   "id": 79,
   "type": "decal"
  },
  {
   "id": 80,
   "type": "decal"
  },
  {
   "id": 81,
   "type": "decal"
  },
  {
   "id": 82,
   "type": "decal"
  },
  {
   "id": 87,
   "type": "decal"
  },
  {
   "id": 88,
   "type": "decal"
  },
  {
   "id": 89,
   "type": "decal"
  },
  {
   "id": 90,
   "type": "decal"
  },
  {
   "id": 92,
   "type": "decal"
  },
  {
   "id": 93,
   "type": "decal"
  },
  {
   "id": 97,
   "type": "decal"
  },
  {
   "id": 100,
   "type": "decal"
  },
  {
   "id": 101,
   "type": "decal"
  },
  {
   "id": 106,
   "type": "decal"
  },
  {
   "id": 107,
   "type": "decal"
  },
  {
   "id": 108,
   "type": "decal"
  },
  {
   "id": 109,
   "type": "decal"
  },
  {
   "id": 110,
   "type": "decal"
  },
  {
   "id": 126,
   "type": "decal"
  },
  {
   "id": 127,
   "type": "decal"
  },
  {
   "id": 128,
   "type": "decal"
  },
  {
   "id": 129,
   "type": "decal"
  },
  {
   "id": 130,
   "type": "decal"
  },
  {
   "id": 131,
   "type": "decal"
  },
  {
   "id": 132,
   "type": "decal"
  },
  {
   "id": 133,
   "type": "decal"
  },
  {
   "id": 135,
   "type": "decal"
  },
  {
   "id": 136,
   "type": "decal"
  },
  {
   "id": 137,
   "type": "decal"
  },
  {
   "id": 138,
   "type": "decal"
  },
  {
   "id": 139,
   "type": "decal"
  },
  {
   "id": 140,
   "type": "decal"
  },
  {
   "id": 143,
   "type": "decal"
  },
  {
   "id": 144,
   "type": "decal"
  },
  {
   "id": 145,
   "type": "decal"
  },
  {
   "id": 146,
   "type": "decal"
  },
  {
   "id": 147,
   "type": "decal"
  },
  {
   "id": 148,
   "type": "decal"
  },
  {
   "id": 149,
   "type": "decal"
  },
  {
   "id": 150,
   "type": "decal"
  },
  {
   "id": 151,
   "type": "decal"
  },
  {
   "id": 154,
   "type": "decal"
  },
  {
   "id": 155,
   "type": "decal"
  },
  {
   "id": 156,
   "type": "decal"
  },
  {
   "id": 157,
   "type": "decal"
  },
  {
   "id": 158,
   "type": "decal"
  },
  {
   "id": 159,
   "type": "decal"
  },
  {
   "id": 160,
   "type": "decal"
  },
  {
   "id": 163,
   "type": "decal"
  },
  {
   "id": 164,
   "type": "decal"
  },
  {
   "id": 165,
   "type": "decal"
  },
  {
   "id": 166,
   "type": "decal"
  },
  {
   "id": 167,
   "type": "decal"
  },
  {
   "id": 168,
   "type": "decal"
  },
  {
   "id": 175,
   "type": "decal"
  },
  {
   "id": 176,
   "type": "decal"
  },
  {
   "id": 177,
   "type": "decal"
  },
  {
   "id": 178,
   "type": "decal"
  },
  {
   "id": 179,
   "type": "decal"
  },
  {
   "id": 180,
   "type": "decal"
  },
  {
   "id": 181,
   "type": "decal"
  },
  {
   "id": 184,
   "type": "ground"
  },
  {
   "id": 185,
   "type": "ground"
  },
  {
   "id": 186,
   "type": "ground"
  },
  {
   "id": 187,
   "type": "ground"
  },
  {
   "id": 188,
   "type": "ground"
  },
  {
   "id": 189,
   "type": "ground"
  },
  {
   "id": 190,
   "type": "ground"
  },
  {
   "id": 191,
   "type": "decal"
  },
  {
   "id": 193,
   "type": "ground"
  },
  {
   "id": 194,
   "type": "ground"
  },
  {
   "id": 195,
   "type": "ground"
  },
  {
   "id": 196,
   "type": "ground"
  },
  {
   "id": 197,
   "type": "ground"
  },
  {
   "id": 198,
   "type": "ground"
  },
  {
   "id": 199,
   "type": "ground"
  },
  {
   "id": 201,
   "type": "decal"
  },
  {
   "id": 202,
   "type": "ground"
  },
  {
   "id": 203,
   "type": "ground"
  },
  {
   "id": 204,
   "type": "ground"
  },
  {
   "id": 205,
   "type": "ground"
  },
  {
   "id": 206,
   "type": "ground"
  },
  {
   "id": 207,
   "type": "ground"
  },
  {
   "id": 208,
   "type": "ground"
  },
  {
   "id": 209,
   "type": "decal"
  },
  {
   "id": 212,
   "type": "ground"
  },
  {
   "id": 213,
   "type": "ground"
  },
  {
   "id": 214,
   "type": "ground"
  },
  {
   "id": 215,
   "type": "ground"
  },
  {
   "id": 216,
   "type": "ground"
  },
  {
   "id": 217,
   "type": "ground"
  },
  {
   "id": 218,
   "type": "ground"
  },
  {
   "id": 219,
   "type": "decal"
  },
  {
   "id": 221,
   "type": "ground"
  },
  {
   "id": 222,
   "type": "ground"
  },
  {
   "id": 223,
   "type": "ground"
  },
  {
   "id": 224,
   "type": "ground"
  },
  {
   "id": 225,
   "type": "ground"
  },
  {
   "id": 226,
   "type": "ground"
  },
  {
   "id": 227,
   "type": "ground"
  },
  {
   "id": 233,
   "type": "decal"
  },
  {
   "id": 234,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "id": 2,
    "name": "",
    "objects": [
     {
      "height": 16,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 1,
      "x": 0,
      "y": 0
     }
    ],
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0
   }
  },
  {
   "id": 235,
   "type": "decal"
  },
  {
   "id": 236,
   "type": "decal"
  },
  {
   "id": 237,
   "type": "decal"
  },
  {
   "id": 238,
   "type": "decal"
  },
  {
   "id": 239,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "id": 2,
    "name": "",
    "objects": [
     {
      "height": 16,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 1,
      "x": 5,
      "y": 0
     }
    ],
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0
   }
  },
  {
   "id": 242,
   "type": "ground"
  },
  {
   "id": 243,
   "type": "ground"
  },
  {
   "id": 244,
   "type": "ground"
  },
  {
   "id": 245,
   "type": "ground"
  },
  {
   "id": 246,
   "type": "ground"
  },
  {
   "id": 247,
   "type": "ground"
  },
  {
   "id": 248,
   "type": "ground"
  },
  {
   "id": 251,
   "type": "ground"
  },
  {
   "id": 252,
   "type": "ground"
  },
  {
   "id": 253,
   "type": "ground"
  },
  {
   "id": 254,
   "type": "ground"
  },
  {
   "id": 255,
   "type": "ground"
  },
  {
   "id": 256,
   "type": "ground"
  },
  {
   "id": 257,
   "type": "ground"
  },
  {
   "id": 260,
   "type": "ground"
  },
  {
   "id": 261,
   "type": "ground"
  },
  {
   "id": 262,
   "type": "ground"
  },
  {
   "id": 263,
   "type": "ground"
  },
  {
   "id": 264,
   "type": "ground"
  },
  {
   "id": 265,
   "type": "ground"
  },
  {
   "id": 266,
   "type": "ground"
  },
  {
   "id": 270,
   "type": "ground"
  },
  {
   "id": 271,
   "type": "ground"
  },
  {
   "id": 272,
   "type": "ground"
  },
  {
   "id": 273,
   "type": "ground"
  },
  {
   "id": 274,
   "type": "ground"
  },
  {
   "id": 275,
   "type": "ground"
  },
  {
   "id": 276,
   "type": "ground"
  },
  {
   "id": 279,
   "type": "ground"
  },
  {
   "id": 280,
   "type": "ground"
  },
  {
   "id": 281,
   "type": "ground"
  },
  {
   "id": 282,
   "type": "ground"
  },
  {
   "id": 283,
   "type": "ground"
  },
  {
   "id": 284,
   "type": "ground"
  },
  {
   "id": 285,
   "type": "ground"
  },
  {
   "id": 291,
   "type": "decal"
  },
  {
   "id": 292,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "id": 3,
    "name": "",
    "objects": [
     {
      "height": 6,
      "id": 2,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 16,
      "x": 0,
      "y": 10
     }
    ],
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0
   }
  },
  {
   "id": 293,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "id": 3,
    "name": "",
    "objects": [
     {
      "height": 6,
      "id": 5,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 16,
      "x": 0,
      "y": 10
     }
    ],
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0
   }
  },
  {
   "id": 294,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "id": 2,
    "name": "",
    "objects": [
     {
      "height": 6,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 16,
      "x": 0,
      "y": 10
     }
    ],
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0
   }
  },
  {
   "id": 295,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "id": 2,
    "name": "",
    "objects": [
     {
      "height": 6,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 16,
      "x": 0,
      "y": 10
     }
    ],
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0
   }
  },
  {
   "id": 296,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "id": 2,
    "name": "",
    "objects": [
     {
      "height": 6,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 16,
      "x": 0,
      "y": 10
     }
    ],
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0
   }
  },
  {
   "id": 297,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "id": 2,
    "name": "",
    "objects": [
     {
      "height": 6,
      "id": 2,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 6,
      "x": 0,
      "y": 10
     }
    ],
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0
   }
  },
  {
   "id": 300,
   "type": "ground"
  },
  {
   "id": 301,
   "type": "ground"
  },
  {
   "id": 302,
   "type": "ground"
  },
  {
   "id": 303,
   "type": "ground"
  },
  {
   "id": 304,
   "type": "ground"
  },
  {
   "id": 305,
   "type": "ground"
  },
  {
   "id": 306,
   "type": "ground"
  },
  {
   "id": 309,
   "type": "ground"
  },
  {
   "id": 310,
   "type": "ground"
  },
  {
   "id": 311,
   "type": "ground"
  },
  {
   "id": 312,
   "type": "ground"
  },
  {
   "id": 313,
   "type": "ground"
  },
  {
   "id": 314,
   "type": "ground"
  },
  {
   "id": 315,
   "type": "ground"
  },
  {
   "id": 318,
   "type": "ground"
  },
  {
   "id": 319,
   "type": "ground"
  },
  {
   "id": 320,
   "type": "ground"
  },
  {
   "id": 321,
   "type": "ground"
  },
  {
   "id": 322,
   "type": "ground"
  },
  {
   "id": 323,
   "type": "ground"
  },
  {
   "id": 324,
   "type": "ground"
  },
  {
   "id": 328,
   "type": "ground"
  },
  {
   "id": 329,
   "type": "ground"
  },
  {
   "id": 330,
   "type": "ground"
  },
  {
   "id": 331,
   "type": "ground"
  },
  {
   "id": 332,
   "type": "ground"
  },
  {
   "id": 333,
   "type": "ground"
  },
  {
   "id": 334,
   "type": "ground"
  },
  {
   "id": 337,
   "type": "ground"
  },
  {
   "id": 338,
   "type": "ground"
  },
  {
   "id": 339,
   "type": "ground"
  },
  {
   "id": 340,
   "type": "ground"
  },
  {
   "id": 341,
   "type": "ground"
  },
  {
   "id": 342,
   "type": "ground"
  },
  {
   "id": 343,
   "type": "ground"
  },
  {
   "id": 350,
   "type": "decal"
  },
  {
   "id": 351,
   "type": "decal"
  },
  {
   "id": 354,
   "type": "decal"
  },
  {
   "id": 355,
   "type": "decal"
  },
  {
   "id": 359,
   "type": "decal"
  },
  {
   "id": 360,
   "type": "decal"
  },
  {
   "id": 363,
   "type": "decal"
  },
  {
   "id": 364,
   "type": "decal"
  },
  {
   "id": 367,
   "type": "ground"
  },
  {
   "id": 368,
   "type": "ground"
  },
  {
   "id": 369,
   "type": "ground"
  },
  {
   "id": 370,
   "type": "ground"
  },
  {
   "id": 371,
   "type": "ground"
  },
  {
   "id": 372,
   "type": "ground"
  },
  {
   "id": 373,
   "type": "ground"
  },
  {
   "id": 376,
   "type": "ground"
  },
  {
   "id": 377,
   "type": "ground"
  },
  {
   "id": 378,
   "type": "ground"
  },
  {
   "id": 379,
   "type": "ground"
  },
  {
   "id": 380,
   "type": "ground"
  },
  {
   "id": 381,
   "type": "ground"
  },
  {
   "id": 382,
   "type": "ground"
  },
  {
   "id": 386,
   "type": "decal"
  },
  {
   "id": 387,
   "type": "decal"
  },
  {
   "id": 388,
   "type": "decal"
  },
  {
   "id": 389,
   "type": "decal"
  },
  {
   "id": 390,
   "type": "decal"
  },
  {
   "id": 391,
   "type": "decal"
  },
  {
   "id": 392,
   "type": "decal"
  },
  {
   "id": 395,
   "type": "ground"
  },
  {
   "id": 396,
   "type": "ground"
  },
  {
   "id": 397,
   "type": "ground"
  },
  {
   "id": 398,
   "type": "ground"
  },
  {
   "id": 399,
   "type": "ground"
  },
  {
   "id": 400,
   "type": "ground"
  },
  {
   "id": 401,
   "type": "ground"
  },
  {
   "id": 426,
   "type": "decal"
  },
  {
   "id": 427,
   "type": "decal"
  },
  {
   "id": 428,
   "type": "decal"
  },
  {
   "id": 429,
   "type": "decal"
  },
  {
   "id": 430,
   "type": "decal"
  },
  {
   "id": 431,
   "type": "decal"
  },
  {
   "id": 453,
   "type": "decal"
  },
  {
   "id": 454,
   "type": "decal"
  },
  {
   "id": 455,
   "type": "decal"
  },
  {
   "id": 456,
   "type": "decal"
  },
  {
   "id": 457,
   "type": "decal"
  },
  {
   "id": 458,
   "type": "decal"
  },
  {
   "id": 459,
   "type": "decal"
  },
  {
   "id": 465,
   "type": "decal"
  },
  {
   "id": 466,
   "type": "decal"
  },
  {
   "id": 467,
   "type": "decal"
  },
  {
   "id": 470,
   "type": "decal"
  },
  {
   "id": 471,
   "type": "decal"
  },
  {
   "id": 545,
   "type": "decal"
  },
  {
   "id": 574,
   "type": "decal"
  },
  {
   "id": 602,
   "type": "decal"
  },
  {
   "id": 603,
   "type": "decal"
  },
  {
   "id": 604,
   "type": "decal"
  },
  {
   "id": 605,
   "type": "decal"
  },
  {
   "id": 606,
   "type": "decal"
  },
  {
   "id": 631,
   "type": "decal"
  },
  {
   "id": 632,
   "type": "decal"
  },
  {
   "id": 633,
   "type": "decal"
  },
  {
   "id": 634,
   "type": "decal"
  },
  {
   "id": 635,
   "type": "decal"
  },
  {
   "id": 640,
   "type": "decal"
  },
  {
   "id": 641,
   "type": "decal"
  },
  {
   "id": 642,
   "type": "decal"
  },
  {
   "id": 643,
   "type": "decal"
  },
  {
   "id": 644,
   "type": "decal"
  },
  {
   "id": 645,
   "type": "decal"
  },
  {
   "id": 646,
   "type": "decal"
  },
  {
   "id": 647,
   "type": "decal"
  },
  {
   "id": 651,
   "type": "decal"
  },
  {
   "id": 654,
   "type": "decal"
  },
  {
   "id": 655,
   "type": "decal"
  },
  {
   "id": 659,
   "type": "decal"
  },
  {
   "id": 660,
   "type": "decal"
  },
  {
   "id": 661,
   "type": "decal"
  },
  {
   "id": 662,
   "type": "decal"
  },
  {
   "id": 663,
   "type": "decal"
  },
  {
   "id": 664,
   "type": "decal"
  },
  {
   "id": 670,
   "type": "decal"
  },
  {
   "id": 671,
   "type": "decal"
  },
  {
   "id": 672,
   "type": "decal"
  },
  {
   "id": 673,
   "type": "decal"
  },
  {
   "id": 675,
   "type": "decal"
  },
  {
   "id": 676,
   "type": "decal"
  },
  {
   "id": 680,
   "type": "decal"
  },
  {
   "id": 683,
   "type": "decal"
  },
  {
   "id": 684,
   "type": "decal"
  },
  {
   "id": 688,
   "type": "decal"
  },
  {
   "id": 689,
   "type": "decal"
  },
  {
   "id": 690,
   "type": "decal"
  },
  {
   "id": 691,
   "type": "decal"
  },
  {
   "id": 692,
   "type": "decal"
  },
  {
   "id": 693,
   "type": "decal"
  },
  {
   "id": 697,
   "type": "decal"
  },
  {
   "id": 698,
   "type": "decal"
  },
  {
   "id": 699,
   "type": "decal"
  },
  {
   "id": 700,
   "type": "decal"
  },
  {
   "id": 701,
   "type": "decal"
  },
  {
   "id": 702,
   "type": "decal"
  },
  {
   "id": 703,
   "type": "decal"
  },
  {
   "id": 704,
   "type": "decal"
  },
  {
   "id": 705,
   "type": "decal"
  },
  {
   "id": 708,
   "type": "decal"
  },
  {
   "id": 709,
   "type": "decal"
  },
  {
   "id": 710,
   "type": "decal"
  },
  {
   "id": 711,
   "type": "decal"
  },
  {
   "id": 712,
   "type": "decal"
  },
  {
   "id": 713,
   "type": "decal"
  },
  {
   "id": 714,
   "type": "decal"
  },
  {
   "id": 717,
   "type": "ground"
  },
  {
   "id": 718,
   "type": "ground"
  },
  {
   "id": 719,
   "type": "ground"
  },
  {
   "id": 720,
   "type": "ground"
  },
  {
   "id": 721,
   "type": "ground"
  },
  {
   "id": 722,
   "type": "ground"
  },
  {
   "id": 723,
   "type": "ground"
  },
  {
   "id": 726,
   "type": "decal"
  },
  {
   "id": 727,
   "type": "decal"
  },
  {
   "id": 728,
   "type": "decal"
  },
  {
   "id": 729,
   "type": "decal"
  },
  {
   "id": 730,
   "type": "decal"
  },
  {
   "id": 731,
   "type": "decal"
  },
  {
   "id": 732,
   "type": "decal"
  },
  {
   "id": 733,
   "type": "decal"
  },
  {
   "id": 734,
   "type": "decal"
  },
  {
   "id": 737,
   "type": "decal"
  },
  {
   "id": 738,
   "type": "decal"
  },
  {
   "id": 739,
   "type": "decal"
  },
  {
   "id": 740,
   "type": "decal"
  },
  {
   "id": 741,
   "type": "decal"
  },
  {
   "id": 742,
   "type": "decal"
  },
  {
   "id": 743,
   "type": "decal"
  },
  {
   "id": 746,
   "type": "ground"
  },
  {
   "id": 747,
   "type": "ground"
  },
  {
   "id": 748,
   "type": "ground"
  },
  {
   "id": 749,
   "type": "ground"
  },
  {
   "id": 750,
   "type": "ground"
  },
  {
   "id": 751,
   "type": "ground"
  },
  {
   "id": 752,
   "type": "ground"
  },
  {
   "id": 755,
   "type": "decal"
  },
  {
   "id": 756,
   "type": "ground"
  },
  {
   "id": 757,
   "type": "ground"
  },
  {
   "id": 758,
   "type": "ground"
  },
  {
   "id": 759,
   "type": "ground"
  },
  {
   "id": 760,
   "type": "ground"
  },
  {
   "id": 761,
   "type": "ground"
  },
  {
   "id": 762,
   "type": "ground"
  },
  {
   "id": 763,
   "type": "decal"
  },
  {
   "id": 766,
   "type": "ground"
  },
  {
   "id": 767,
   "type": "ground"
  },
  {
   "id": 768,
   "type": "ground"
  },
  {
   "id": 769,
   "type": "ground"
  },
  {
   "id": 770,
   "type": "ground"
  },
  {
   "id": 771,
   "type": "ground"
  },
  {
   "id": 772,
   "type": "ground"
  },
  {
   "id": 773,
   "type": "decal"
  },
  {
   "id": 775,
   "type": "ground"
  },
  {
   "id": 776,
   "type": "ground"
  },
  {
   "id": 777,
   "type": "ground"
  },
  {
   "id": 778,
   "type": "ground"
  },
  {
   "id": 779,
   "type": "ground"
  },
  {
   "id": 780,
   "type": "ground"
  },
  {
   "id": 781,
   "type": "ground"
  },
  {
   "id": 784,
   "type": "decal"
  },
  {
   "id": 785,
   "type": "ground"
  },
  {
   "id": 786,
   "type": "ground"
  },
  {
   "id": 787,
   "type": "ground"
  },
  {
   "id": 788,
   "type": "ground"
  },
  {
   "id": 789,
   "type": "ground"
  },
  {
   "id": 790,
   "type": "ground"
  },
  {
   "id": 791,
   "type": "ground"
  },
  {
   "id": 792,
   "type": "decal"
  },
  {
   "id": 795,
   "type": "ground"
  },
  {
   "id": 796,
   "type": "ground"
  },
  {
   "id": 797,
   "type": "ground"
  },
  {
   "id": 798,
   "type": "ground"
  },
  {
   "id": 799,
   "type": "ground"
  },
  {
   "id": 800,
   "type": "ground"
  },
  {
   "id": 801,
   "type": "ground"
  },
  {
   "id": 802,
   "type": "decal"
  },
  {
   "id": 804,
   "type": "ground"
  },
  {
   "id": 805,
   "type": "ground"
  },
  {
   "id": 806,
   "type": "ground"
  },
  {
   "id": 807,
   "type": "ground"
  },
  {
   "id": 808,
   "type": "ground"
  },
  {
   "id": 809,
   "type": "ground"
  },
  {
   "id": 810,
   "type": "ground"
  },
  {
   "id": 814,
   "type": "ground"
  },
  {
   "id": 815,
   "type": "ground"
  },
  {
   "id": 816,
   "type": "ground"
  },
  {
   "id": 817,
   "type": "ground"
  },
  {
   "id": 818,
   "type": "ground"
  },
  {
   "id": 819,
   "type": "ground"
  },
  {
   "id": 820,
   "type": "ground"
  },
  {
   "id": 824,
   "type": "ground"
  },
  {
   "id": 825,
   "type": "ground"
  },
  {
   "id": 826,
   "type": "ground"
  },
  {
   "id": 827,
   "type": "ground"
  },
  {
   "id": 828,
   "type": "ground"
  },
  {
   "id": 829,
   "type": "ground"
  },
  {
   "id": 830,
   "type": "ground"
  },
  {
   "id": 833,
   "type": "ground"
  },
  {
   "id": 834,
   "type": "ground"
  },
  {
   "id": 835,
   "type": "ground"
  },
  {
   "id": 836,
   "type": "ground"
  },
  {
   "id": 837,
   "type": "ground"
  },
  {
   "id": 838,
   "type": "ground"
  },
  {
   "id": 839,
   "type": "ground"
  },
  {
   "id": 843,
   "type": "ground"
  },
  {
   "id": 844,
   "type": "ground"
  },
  {
   "id": 845,
   "type": "ground"
  },
  {
   "id": 846,
   "type": "ground"
  },
  {
   "id": 847,
   "type": "ground"
  },
  {
   "id": 848,
   "type": "ground"
  },
  {
   "id": 849,
   "type": "ground"
  },
  {
   "id": 853,
   "type": "ground"
  },
  {
   "id": 854,
   "type": "ground"
  },
  {
   "id": 855,
   "type": "ground"
  },
  {
   "id": 856,
   "type": "ground"
  },
  {
   "id": 857,
   "type": "ground"
  },
  {
   "id": 858,
   "type": "ground"
  },
  {
   "id": 859,
   "type": "ground"
  },
  {
   "id": 862,
   "type": "ground"
  },
  {
   "id": 863,
   "type": "ground"
  },
  {
   "id": 864,
   "type": "ground"
  },
  {
   "id": 865,
   "type": "ground"
  },
  {
   "id": 866,
   "type": "ground"
  },
  {
   "id": 867,
   "type": "ground"
  },
  {
   "id": 868,
   "type": "ground"
  },
  {
   "id": 872,
   "type": "ground"
  },
  {
   "id": 873,
   "type": "ground"
  },
  {
   "id": 874,
   "type": "ground"
  },
  {
   "id": 875,
   "type": "ground"
  },
  {
   "id": 876,
   "type": "ground"
  },
  {
   "id": 877,
   "type": "ground"
  },
  {
   "id": 878,
   "type": "ground"
  },
  {
   "id": 882,
   "type": "ground"
  },
  {
   "id": 883,
   "type": "ground"
  },
  {
   "id": 884,
   "type": "ground"
  },
  {
   "id": 885,
   "type": "ground"
  },
  {
   "id": 886,
   "type": "ground"
  },
  {
   "id": 887,
   "type": "ground"
  },
  {
   "id": 888,
   "type": "ground"
  },
  {
   "id": 891,
   "type": "ground"
  },
  {
   "id": 892,
   "type": "ground"
  },
  {
   "id": 893,
   "type": "ground"
  },
  {
   "id": 894,
   "type": "ground"
  },
  {
   "id": 895,
   "type": "ground"
  },
  {
   "id": 896,
   "type": "ground"
  },
  {
   "id": 897,
   "type": "ground"
  },
  {
   "id": 901,
   "type": "ground"
  },
  {
   "id": 902,
   "type": "ground"
  },
  {
   "id": 903,
   "type": "ground"
  },
  {
   "id": 904,
   "type": "ground"
  },
  {
   "id": 905,
   "type": "ground"
  },
  {
   "id": 906,
   "type": "ground"
  },
  {
   "id": 907,
   "type": "ground"
  },
  {
   "id": 911,
   "type": "ground"
  },
  {
   "id": 912,
   "type": "ground"
  },
  {
   "id": 913,
   "type": "ground"
  },
  {
   "id": 914,
   "type": "ground"
  },
  {
   "id": 915,
   "type": "ground"
  },
  {
   "id": 916,
   "type": "ground"
  },
  {
   "id": 917,
   "type": "ground"
  },
  {
   "id": 920,
   "type": "ground"
  },
  {
   "id": 921,
   "type": "ground"
  },
  {
   "id": 922,
   "type": "ground"
  },
  {
   "id": 923,
   "type": "ground"
  },
  {
   "id": 924,
   "type": "ground"
  },
  {
   "id": 925,
   "type": "ground"
  },
  {
   "id": 926,
   "type": "ground"
  },
  {
   "id": 930,
   "type": "decal"
  },
  {
   "id": 931,
   "type": "decal"
  },
  {
   "id": 932,
   "type": "decal"
  },
  {
   "id": 933,
   "type": "decal"
  },
  {
   "id": 934,
   "type": "decal"
  },
  {
   "id": 935,
   "type": "decal"
  },
  {
   "id": 936,
   "type": "decal"
  },
  {
   "id": 940,
   "type": "decal"
  },
  {
   "id": 941,
   "type": "decal"
  },
  {
   "id": 942,
   "type": "decal"
  },
  {
   "id": 943,
   "type": "decal"
  },
  {
   "id": 944,
   "type": "decal"
  },
  {
   "id": 945,
   "type": "decal"
  },
  {
   "id": 946,
   "type": "decal"
  },
  {
   "id": 949,
   "type": "decal"
  },
  {
   "id": 950,
   "type": "decal"
  },
  {
   "id": 951,
   "type": "decal"
  },
  {
   "id": 952,
   "type": "decal"
  },
  {
   "id": 953,
   "type": "decal"
  },
  {
   "id": 954,
   "type": "decal"
  },
  {
   "id": 955,
   "type": "decal"
  },
  {
   "id": 959,
   "type": "decal"
  },
  {
   "id": 960,
   "type": "decal"
  },
  {
   "id": 961,
   "type": "decal"
  },
  {
   "id": 962,
   "type": "decal"
  },
  {
   "id": 963,
   "type": "decal"
  },
  {
   "id": 964,
   "type": "decal"
  },
  {
   "id": 965,
   "type": "decal"
  },
  {
   "id": 969,
   "type": "decal"
  },
  {
   "id": 970,
   "type": "decal"
  },
  {
   "id": 971,
   "type": "decal"
  },
  {
   "id": 972,
   "type": "decal"
  },
  {
   "id": 973,
   "type": "decal"
  },
  {
   "id": 974,
   "type": "decal"
  },
  {
   "id": 975,
   "type": "decal"
  },
  {
   "id": 978,
   "type": "decal"
  },
  {
   "id": 979,
   "type": "decal"
  },
  {
   "id": 980,
   "type": "decal"
  },
  {
   "id": 981,
   "type": "decal"
  },
  {
   "id": 982,
   "type": "decal"
  },
  {
   "id": 983,
   "type": "decal"
  },
  {
   "id": 984,
   "type": "decal"
  },
  {
   "id": 1066,
   "type": "decal"
  },
  {
   "id": 1096,
   "type": "decal"
  },
  {
   "id": 1102,
   "type": "decal"
  },
  {
   "id": 1103,
   "type": "decal"
  },
  {
   "id": 1104,
   "type": "decal"
  },
  {
   "id": 1105,
   "type": "decal"
  },
  {
   "id": 1106,
   "type": "decal"
  },
  {
   "id": 1107,
   "type": "decal"
  },
  {
   "id": 1108,
   "type": "decal"
  },
  {
   "id": 1109,
   "type": "decal"
  },
  {
   "id": 1110,
   "type": "decal"
  },
  {
   "id": 1114,
   "type": "decal"
  },
  {
   "id": 1117,
   "type": "decal"
  },
  {
   "id": 1118,
   "type": "decal"
  },
  {
   "id": 1123,
   "type": "decal"
  },
  {
   "id": 1124,
   "type": "decal"
  },
  {
   "id": 1125,
   "type": "decal"
  },
  {
   "id": 1126,
   "type": "decal"
  },
  {
   "id": 1127,
   "type": "decal"
  },
  {
   "id": 1146,
   "type": "decal"
  },
  {
   "id": 1147,
   "type": "decal"
  },
  {
   "id": 1153,
   "type": "decal"
  },
  {
   "id": 1154,
   "type": "decal"
  },
  {
   "id": 1155,
   "type": "decal"
  },
  {
   "id": 1156,
   "type": "decal"
  },
  {
   "id": 1157,
   "type": "decal"
  },
  {
   "id": 1160,
   "type": "decal"
  },
  {
   "id": 1161,
   "type": "decal"
  },
  {
   "id": 1162,
   "type": "decal"
  },
  {
   "id": 1163,
   "type": "decal"
  },
  {
   "id": 1164,
   "type": "decal"
  },
  {
   "id": 1165,
   "type": "decal"
  },
  {
   "id": 1166,
   "type": "decal"
  },
  {
   "id": 1167,
   "type": "decal"
  },
  {
   "id": 1168,
   "type": "decal"
  },
  {
   "id": 1171,
   "type": "decal"
  },
  {
   "id": 1172,
   "type": "decal"
  },
  {
   "id": 1173,
   "type": "decal"
  },
  {
   "id": 1174,
   "type": "decal"
  },
  {
   "id": 1175,
   "type": "decal"
  },
  {
   "id": 1176,
   "type": "decal"
  },
  {
   "id": 1177,
   "type": "decal"
  },
  {
   "id": 1180,
   "type": "decal"
  },
  {
   "id": 1181,
   "type": "decal"
  },
  {
   "id": 1182,
   "type": "decal"
  },
  {
   "id": 1183,
   "type": "decal"
  },
  {
   "id": 1184,
   "type": "decal"
  },
  {
   "id": 1185,
   "type": "decal"
  },
  {
   "id": 1189,
   "type": "decal"
  },
  {
   "id": 1190,
   "type": "decal"
  },
  {
   "id": 1191,
   "type": "decal"
  },
  {
   "id": 1192,
   "type": "decal"
  },
  {
   "id": 1193,
   "type": "decal"
  },
  {
   "id": 1194,
   "type": "decal"
  },
  {
   "id": 1195,
   "type": "decal"
  },
  {
   "id": 1196,
   "type": "decal"
  },
  {
   "id": 1197,
   "type": "decal"
  },
  {
   "id": 1200,
   "type": "decal"
  },
  {
   "id": 1201,
   "type": "decal"
  },
  {
   "id": 1202,
   "type": "decal"
  },
  {
   "id": 1203,
   "type": "decal"
  },
  {
   "id": 1204,
   "type": "decal"
  },
  {
   "id": 1205,
   "type": "decal"
  },
  {
   "id": 1206,
   "type": "decal"
  },
  {
   "id": 1210,
   "type": "decal"
  },
  {
   "id": 1211,
   "type": "decal"
  },
  {
   "id": 1212,
   "type": "decal"
  },
  {
   "id": 1213,
   "type": "decal"
  },
  {
   "id": 1214,
   "type": "decal"
  },
  {
   "id": 1215,
   "type": "decal"
  },
  {
   "id": 1218,
   "type": "decal"
  },
  {
   "id": 1219,
   "type": "ground"
  },
  {
   "id": 1220,
   "type": "ground"
  },
  {
   "id": 1221,
   "type": "ground"
  },
  {
   "id": 1222,
   "type": "ground"
  },
  {
   "id": 1223,
   "type": "ground"
  },
  {
   "id": 1224,
   "type": "ground"
  },
  {
   "id": 1225,
   "type": "ground"
  },
  {
   "id": 1226,
   "type": "decal"
  },
  {
   "id": 1229,
   "type": "ground"
  },
  {
   "id": 1230,
   "type": "ground"
  },
  {
   "id": 1231,
   "type": "ground"
  },
  {
   "id": 1232,
   "type": "ground"
  },
  {
   "id": 1233,
   "type": "ground"
  },
  {
   "id": 1234,
   "type": "ground"
  },
  {
   "id": 1235,
   "type": "ground"
  },
  {
   "id": 1236,
   "type": "decal"
  },
  {
   "id": 1238,
   "type": "ground"
  },
  {
   "id": 1239,
   "type": "ground"
  },
  {
   "id": 1240,
   "type": "ground"
  },
  {
   "id": 1241,
   "type": "ground"
  },
  {
   "id": 1242,
   "type": "ground"
  },
  {
   "id": 1243,
   "type": "ground"
  },
  {
   "id": 1244,
   "type": "ground"
  },
  {
   "id": 1247,
   "type": "decal"
  },
  {
   "id": 1248,
   "type": "decal"
  },
  {
   "id": 1249,
   "type": "decal"
  },
  {
   "id": 1250,
   "type": "decal"
  },
  {
   "id": 1251,
   "type": "decal"
  },
  {
   "id": 1252,
   "type": "decal"
  },
  {
   "id": 1253,
   "type": "decal"
  },
  {
   "id": 1254,
   "type": "decal"
  },
  {
   "id": 1255,
   "type": "decal"
  },
  {
   "id": 1258,
   "type": "ground"
  },
  {
   "id": 1259,
   "type": "ground"
  },
  {
   "id": 1260,
   "type": "ground"
  },
  {
   "id": 1261,
   "type": "ground"
  },
  {
   "id": 1262,
   "type": "ground"
  },
  {
   "id": 1263,
   "type": "ground"
  },
  {
   "id": 1264,
   "type": "ground"
  },
  {
   "id": 1265,
   "type": "decal"
  },
  {
   "id": 1268,
   "type": "ground"
  },
  {
   "id": 1269,
   "type": "ground"
  },
  {
   "id": 1270,
   "type": "ground"
  },
  {
   "id": 1271,
   "type": "ground"
  },
  {
   "id": 1272,
   "type": "ground"
  },
  {
   "id": 1273,
   "type": "ground"
  },
  {
   "id": 1274,
   "type": "ground"
  },
  {
   "id": 1277,
   "type": "ground"
  },
  {
   "id": 1278,
   "type": "ground"
  },
  {
   "id": 1279,
   "type": "ground"
  },
  {
   "id": 1280,
   "type": "ground"
  },
  {
   "id": 1281,
   "type": "ground"
  },
  {
   "id": 1282,
   "type": "ground"
  },
  {
   "id": 1283,
   "type": "ground"
  },
  {
   "id": 1287,
   "type": "ground"
  },
  {
   "id": 1288,
   "type": "ground"
  },
  {
   "id": 1289,
   "type": "ground"
  },
  {
   "id": 1290,
   "type": "ground"
  },
  {
   "id": 1291,
   "type": "ground"
  },
  {
   "id": 1292,
   "type": "ground"
  },
  {
   "id": 1293,
   "type": "ground"
  },
  {
   "id": 1296,
   "type": "ground"
  },
  {
   "id": 1297,
   "type": "ground"
  },
  {
   "id": 1298,
   "type": "ground"
  },
  {
   "id": 1299,
   "type": "ground"
  },
  {
   "id": 1300,
   "type": "ground"
  },
  {
   "id": 1301,
   "type": "ground"
  },
  {
   "id": 1302,
   "type": "ground"
  },
  {
   "id": 1305,
   "type": "decal"
  },
  {
   "id": 1306,
   "type": "ground"
  },
  {
   "id": 1307,
   "type": "ground"
  },
  {
   "id": 1308,
   "type": "ground"
  },
  {
   "id": 1309,
   "type": "ground"
  },
  {
   "id": 1310,
   "type": "ground"
  },
  {
   "id": 1311,
   "type": "ground"
  },
  {
   "id": 1312,
   "type": "ground"
  },
  {
   "id": 1313,
   "type": "decal"
  },
  {
   "id": 1316,
   "type": "ground"
  },
  {
   "id": 1317,
   "type": "ground"
  },
  {
   "id": 1318,
   "type": "ground"
  },
  {
   "id": 1319,
   "type": "ground"
  },
  {
   "id": 1320,
   "type": "ground"
  },
  {
   "id": 1321,
   "type": "ground"
  },
  {
   "id": 1322,
   "type": "ground"
  },
  {
   "id": 1323,
   "type": "decal"
  },
  {
   "id": 1326,
   "type": "ground"
  },
  {
   "id": 1327,
   "type": "ground"
  },
  {
   "id": 1328,
   "type": "ground"
  },
  {
   "id": 1329,
   "type": "ground"
  },
  {
   "id": 1330,
   "type": "ground"
  },
  {
   "id": 1331,
   "type": "ground"
  },
  {
   "id": 1332,
   "type": "ground"
  },
  {
   "id": 1335,
   "type": "ground"
  },
  {
   "id": 1336,
   "type": "ground"
  },
  {
   "id": 1337,
   "type": "ground"
  },
  {
   "id": 1338,
   "type": "ground"
  },
  {
   "id": 1339,
   "type": "ground"
  },
  {
   "id": 1340,
   "type": "ground"
  },
  {
   "id": 1341,
   "type": "ground"
  },
  {
   "id": 1345,
   "type": "ground"
  },
  {
   "id": 1346,
   "type": "ground"
  },
  {
   "id": 1347,
   "type": "ground"
  },
  {
   "id": 1348,
   "type": "ground"
  },
  {
   "id": 1349,
   "type": "ground"
  },
  {
   "id": 1350,
   "type": "ground"
  },
  {
   "id": 1351,
   "type": "ground"
  },
  {
   "id": 1354,
   "type": "ground"
  },
  {
   "id": 1355,
   "type": "ground"
  },
  {
   "id": 1356,
   "type": "ground"
  },
  {
   "id": 1357,
   "type": "ground"
  },
  {
   "id": 1358,
   "type": "ground"
  },
  {
   "id": 1359,
   "type": "ground"
  },
  {
   "id": 1360,
   "type": "ground"
  },
  {
   "id": 1364,
   "type": "ground"
  },
  {
   "id": 1365,
   "type": "ground"
  },
  {
   "id": 1366,
   "type": "ground"
  },
  {
   "id": 1367,
   "type": "ground"
  },
  {
   "id": 1368,
   "type": "ground"
  },
  {
   "id": 1369,
   "type": "ground"
  },
  {
   "id": 1370,
   "type": "ground"
  },
  {
   "id": 1374,
   "type": "ground"
  },
  {
   "id": 1375,
   "type": "ground"
  },
  {
   "id": 1376,
   "type": "ground"
  },
  {
   "id": 1377,
   "type": "ground"
  },
  {
   "id": 1378,
   "type": "ground"
  },
  {
   "id": 1379,
   "type": "ground"
  },
  {
   "id": 1380,
   "type": "ground"
  },
  {
   "id": 1384,
   "type": "ground"
  },
  {
   "id": 1385,
   "type": "ground"
  },
  {
   "id": 1386,
   "type": "ground"
  },
  {
   "id": 1387,
   "type": "ground"
  },
  {
   "id": 1388,
   "type": "ground"
  },
  {
   "id": 1389,
   "type": "ground"
  },
  {
   "id": 1390,
   "type": "ground"
  },
  {
   "id": 1393,
   "type": "decal"
  },
  {
   "id": 1394,
   "type": "decal"
  },
  {
   "id": 1395,
   "type": "decal"
  },
  {
   "id": 1396,
   "type": "decal"
  },
  {
   "id": 1397,
   "type": "decal"
  },
  {
   "id": 1398,
   "type": "decal"
  },
  {
   "id": 1399,
   "type": "decal"
  },
  {
   "id": 1403,
   "type": "decal"
  },
  {
   "id": 1404,
   "type": "decal"
  },
  {
   "id": 1405,
   "type": "decal"
  },
  {
   "id": 1406,
   "type": "decal"
  },
  {
   "id": 1407,
   "type": "decal"
  },
  {
   "id": 1408,
   "type": "decal"
  },
  {
   "id": 1409,
   "type": "decal"
  },
  {
   "id": 1412,
   "type": "ground"
  },
  {
   "id": 1413,
   "type": "ground"
  },
  {
   "id": 1414,
   "type": "ground"
  },
  {
   "id": 1415,
   "type": "ground"
  },
  {
   "id": 1416,
   "type": "ground"
  },
  {
   "id": 1417,
   "type": "ground"
  },
  {
   "id": 1418,
   "type": "ground"
  },
  {
   "id": 1422,
   "type": "ground"
  },
  {
   "id": 1423,
   "type": "ground"
  },
  {
   "id": 1424,
   "type": "ground"
  },
  {
   "id": 1425,
   "type": "ground"
  },
  {
   "id": 1426,
   "type": "ground"
  },
  {
   "id": 1427,
   "type": "ground"
  },
  {
   "id": 1428,
   "type": "ground"
  },
  {
   "id": 1432,
   "type": "ground"
  },
  {
   "id": 1433,
   "type": "ground"
  },
  {
   "id": 1434,
   "type": "ground"
  },
  {
   "id": 1435,
   "type": "ground"
  },
  {
   "id": 1436,
   "type": "ground"
  },
  {
   "id": 1437,
   "type": "ground"
  },
  {
   "id": 1438,
   "type": "ground"
  },
  {
   "id": 1442,
   "type": "ground"
  },
  {
   "id": 1443,
   "type": "ground"
  },
  {
   "id": 1444,
   "type": "ground"
  },
  {
   "id": 1445,
   "type": "ground"
  },
  {
   "id": 1446,
   "type": "ground"
  },
  {
   "id": 1447,
   "type": "ground"
  },
  {
   "id": 1448,
   "type": "ground"
  },
  {
   "id": 1470,
   "type": "decal"
  },
  {
   "id": 1471,
   "type": "decal"
  },
  {
   "id": 1472,
   "type": "decal"
  },
  {
   "id": 1473,
   "type": "decal"
  },
  {
   "id": 1474,
   "type": "decal"
  },
  {
   "id": 1475,
   "type": "decal"
  },
  {
   "id": 1476,
   "type": "decal"
  },
  {
   "id": 1480,
   "type": "decal"
  },
  {
   "id": 1481,
   "type": "decal"
  },
  {
   "id": 1482,
   "type": "decal"
  },
  {
   "id": 1483,
   "type": "decal"
  },
  {
   "id": 1484,
   "type": "decal"
  },
  {
   "id": 1485,
   "type": "decal"
  },
  {
   "id": 1486,
   "type": "decal"
  },
  {
   "id": 1491,
   "type": "decal"
  },
  {
   "id": 1495,
   "type": "decal"
  },
  {
   "id": 1496,
   "type": "decal"
  },
  {
   "id": 1500,
   "type": "decal"
  },
  {
   "id": 1501,
   "type": "decal"
  },
  {
   "id": 1502,
   "type": "decal"
  },
  {
   "id": 1503,
   "type": "decal"
  },
  {
   "id": 1504,
   "type": "decal"
  },
  {
   "id": 1505,
   "type": "decal"
  },
  {
   "id": 1506,
   "type": "decal"
  },
  {
   "id": 1625,
   "type": "decal"
  },
  {
   "id": 1626,
   "type": "decal"
  },
  {
   "id": 1627,
   "type": "decal"
  },
  {
   "id": 1628,
   "type": "decal"
  },
  {
   "id": 1629,
   "type": "decal"
  },
  {
   "id": 1630,
   "type": "decal"
  },
  {
   "id": 1631,
   "type": "decal"
  },
  {
   "id": 1632,
   "type": "decal"
  },
  {
   "id": 1633,
   "type": "decal"
  },
  {
   "id": 1683,
   "type": "decal"
  },
  {
   "id": 1684,
   "type": "decal"
  },
  {
   "id": 1685,
   "type": "decal"
  },
  {
   "id": 1686,
   "type": "decal"
  },
  {
   "id": 1687,
   "type": "decal"
  },
  {
   "id": 1688,
   "type": "decal"
  },
  {
   "id": 1689,
   "type": "decal"
  },
  {
   "id": 1690,
   "type": "decal"
  },
  {
   "id": 1691,
   "type": "decal"
  },
  {
   "id": 1741,
   "type": "decal"
  },
  {
   "id": 1742,
   "type": "ground"
  },
  {
   "id": 1743,
   "type": "ground"
  },
  {
   "id": 1744,
   "type": "ground"
  },
  {
   "id": 1745,
   "type": "ground"
  },
  {
   "id": 1746,
   "type": "ground"
  },
  {
   "id": 1747,
   "type": "ground"
  },
  {
   "id": 1748,
   "type": "ground"
  },
  {
   "id": 1749,
   "type": "decal"
  },
  {
   "id": 1800,
   "type": "ground"
  },
  {
   "id": 1801,
   "type": "ground"
  },
  {
   "id": 1802,
   "type": "ground"
  },
  {
   "id": 1803,
   "type": "ground"
  },
  {
   "id": 1804,
   "type": "ground"
  },
  {
   "id": 1805,
   "type": "ground"
  },
  {
   "id": 1806,
   "type": "ground"
  },
  {
   "id": 1858,
   "type": "ground"
  },
  {
   "id": 1859,
   "type": "ground"
  },
  {
   "id": 1860,
   "type": "ground"
  },
  {
   "id": 1861,
   "type": "ground"
  },
  {
   "id": 1862,
   "type": "ground"
  },
  {
   "id": 1863,
   "type": "ground"
  },
  {
   "id": 1864,
   "type": "ground"
  },
  {
   "id": 1916,
   "type": "decal"
  },
  {
   "id": 1917,
   "type": "decal"
  },
  {
   "id": 1918,
   "type": "decal"
  },
  {
   "id": 1919,
   "type": "decal"
  },
  {
   "id": 1920,
   "type": "decal"
  },
  {
   "id": 1921,
   "type": "decal"
  },
  {
   "id": 1922,
   "type": "decal"
  }
 ],
 "tilewidth": 16,
 "type": "tileset",
 "version": "1.10"
};